import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Edit information
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestUpdateInformation = packet => {
  return {
    type: 'REQUEST_UPDATE_INFORMATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveUpdateInformationSuccess = data => ({
  type: 'RECEIVE_UPDATE_INFORMATION_SUCCESS',
  data
})

export const receiveUpdateInformationFail = data => ({
  type: 'RECEIVE_UPDATE_INFORMATION_FAIL',
  data
})

export const tryToUpdateInformation = packet => (dispatch, getState) => {

  dispatch(requestUpdateInformation(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.knowledge_id + '/information/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUpdateInformationSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveUpdateInformationFail({errors:e, lastSubmit: packet}));
    })
}
